<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue'
import { useForm, useToast } from 'vuestic-ui'
import { newInteraction } from '../../../core/requests/Interactions'
import { validators } from '../../../services/utils'

const emit = defineEmits(['close'])

const props = defineProps({
  data: {
    default: null,
    type: Object,
  },
})

const isLoading = ref(false)
const { isValid, validate } = useForm('formRef')
const form: any = reactive({
  type: 'Comentario',
})
const { notify } = useToast()
const types = ref([
  {
    id: 0,
    label: 'Llamada',
  },
  {
    id: 1,
    label: 'Correo electrónico',
  },
  {
    id: 2,
    label: 'WhatsApp',
  },
  {
    id: 3,
    label: 'Reunión',
  },
  {
    id: 4,
    label: 'Comentario',
  },
])
onMounted(() => {
  if (props.data) {
    //
  }
})

const doProcess = async () => {
  if (validate()) {
    isLoading.value = true
    try {
      await newInteraction({
        user: 1,
        quotation: props.data?.id,
        quotation_status: props.data?.status,
        ...form,
      })

      notify({
        message: 'Interacción registrada correctamente',
        color: 'success',
      })

      emit('close')
    } catch (e: any) {
      console.log(e)
    }

    isLoading.value = false
  }
}
</script>

<template>
  <div class="bg-blue-50">
    <div class="mb-4">
      <div class="flex justify-between align-center justify-center">
        <h1 class="h5 font-bold m-0">Nueva Interacción</h1>
      </div>
    </div>

    <div class="new-customer gap-8">
      <VaForm ref="formRef" immediate class="gap-2">
        <div class="w-full bg-white p-2 mt-3 mb-4 py-5">
          <div class="gap-2">
            <div class="w-full columns-1">
              <div class="w-full">
                <VaSelect
                  v-model="form.type"
                  class="w-full text-xs"
                  label="Tipo de interacción"
                  no-options-text="-- No hay items --"
                  :options="types"
                  value-by="label"
                  text-by="label"
                  placeholder="Selecciona un tipo"
                  :rules="[validators.required]"
                />
              </div>
              <div class="w-full mt-2">
                <VaTextarea
                  v-model="form.comment"
                  class="w-full text-xs"
                  stateful
                  clearable
                  name="comment"
                  label="Comentario"
                  :rules="[validators.required]"
                />
              </div>
            </div>
          </div>
        </div>
      </VaForm>
    </div>

    <div class="pb-3">
      <div class="flex justify-end">
        <div class="flex gap-2">
          <VaButton icon="save" color="primary" :disabled="!isValid" :loading="isLoading" @click="doProcess">
            <span class="text-xs px-1">Registrar Interacción</span>
          </VaButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.new-customer {
  &-tabs {
    .va-tabs__content {
      width: 100%;
    }
  }

  .float-profile {
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
